import React from 'react'
import '../Hull/DroneView.css'
import { ViewEditBox } from '../ViewEditBox'
import { ReactComponent as PilotSvg } from '../../../assets/pilot.svg'

export const AdditionalInsuredView = (props) => {
  return (
    <div className="drone-item-margin">
      <ViewEditBox
        {...props}
        icon={<PilotSvg className="backbuttongray medium-icon" />}
        text={props.ai.name}
      />
    </div>
  )
}
